import { HTTPMethod } from '@perpay-web/constants/httpMethods';
import { getData, useDataModule } from '@perpay-web/data-module/useDataModule';
import { useReduxDataModuleHookConnection } from '@perpay-web/data-module/useReduxDataModuleHookConnection';
import {
    submitMarketplaceCardApplication,
    submitMarketplaceCardApplicationError,
    submitMarketplaceCardApplicationSuccess,
    submitMarketplaceCardApplicationReset,
} from '@perpay-web/fintech/actions/entities/marketplacePartnerOnboarding';
import { PARTNER_ONBOARDING_SUBMIT_MARKETPLACE_CARD_APPLICATION_ENDPOINT } from '@perpay-web/fintech/constants/urls';
import { authenticatedJsonFetch } from '@perpay-web/fintech/utils/requestHandlers';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

export const getSpendingLimit = (state) => {
    const data = getData(state);
    return data ? data.spendingLimit : 0;
};

const useSubmitMarketplaceApplicationDataModule = () => {
    const dataModule = useDataModule((payload) =>
        authenticatedJsonFetch(
            PARTNER_ONBOARDING_SUBMIT_MARKETPLACE_CARD_APPLICATION_ENDPOINT,
            payload,
            HTTPMethod.post,
        ),
    );

    useReduxDataModuleHookConnection({
        dataModule,
        hookAction$,
        request: submitMarketplaceCardApplication,
        error: submitMarketplaceCardApplicationError,
        success: submitMarketplaceCardApplicationSuccess,
        reset: submitMarketplaceCardApplicationReset,
    });

    return dataModule;
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const dataModule = useSubmitMarketplaceApplicationDataModule();

        return (
            <Context.Provider value={dataModule}>{children}</Context.Provider>
        );
    };

    return Provider;
};

export const [
    UseSubmitMarketplaceApplicationDataModuleProvider,
    useSubmitMarketplaceApplicationContext,
] = createContextProvider(providerFactory);
